import type { ReactNode } from 'react';
import { SectionHeader } from '../../../components/SectionHeader';

/**
 * The Assessments section's own header (Redesign Group 6, mockups Tests / Question-bank / Marking):
 * the shared section header with the section's line. The module bar's menu stays as it is; this
 * only repeats it where the work is.
 */

export type AssessmentsPage = 'tests' | 'bank' | 'marking' | 'exam_sessions';

const PAGE_PATHS: Readonly<Record<AssessmentsPage, string>> = {
  tests: '/assessments',
  bank: '/assessments/questions',
  exam_sessions: '/assessments/sessions',
  marking: '/assessments/marking',
};

export function AssessmentsHeader({ current }: { readonly current: AssessmentsPage }): ReactNode {
  return <SectionHeader moduleId="assessments" title="Assessments" lede="Tests candidates take from a link, the question bank and marking." current={PAGE_PATHS[current]} />;
}
